import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppStateService } from 'app/services/app-state.service';
import { FlightConnectionsService } from 'app/services/flight-connections-services';
import { FlightOptionService } from 'app/services/flight-option-service';

import { PageWrapperComponent } from "app/components/ui-kit/page-components/page-wrapper/page-wrapper.component";
import { ConnectionRequestComponent } from "./components/connection-request/connection-request.component";
import { UserService } from 'app/services/user.service';
import { getFriendlyRoute } from 'app/utils/flight/flight-data-utils';
import { ConnectionChatComponent } from "./components/connection-chat/connection-chat.component";
import { FlightConnectionChatService } from 'app/services/flight-connection-chat.service';
import { IconPromptCardComponent } from "app/components/distinct-components/cards/icon-prompt-card/icon-prompt-card.component";


@Component({
  selector: 'app-view-connection',
  standalone: true,
  imports: [CommonModule, PageWrapperComponent, ConnectionRequestComponent, ConnectionChatComponent, IconPromptCardComponent],
  templateUrl: './view-connection.component.html',
  styleUrl: './view-connection.component.scss'
})
export class ViewConnectionComponent {
  connectionData: any;
  flightData: any;
  isLoading: boolean = true;
  connectionStatus: any = null;

  isHandlingAccept: boolean = false;
  isHandlingDecline: boolean = false;

  constructor(
    private route: ActivatedRoute, private flightConnectionService: FlightConnectionsService,
    private flightOptionService: FlightOptionService, public appState: AppStateService,
    private router: Router, private userService: UserService, private chatService: FlightConnectionChatService
  ) { }


  async ngOnInit() {
    const connectionId = this.route.snapshot.paramMap.get('id');
    if (!connectionId) { return; }

    await this.loadConnectionData(connectionId);

    const unread = await this.chatService.hasUnreadNotification(connectionId);
    if (unread) {
      await this.chatService.markNotificationAsSeen(connectionId);
    }

    const backButton = {
      action: 'route',
      value: '/connections'
    }
    this.appState.navigation.backButtonState.set(backButton);
  }

  async loadConnectionData(id) {

    try {
      const connectionData = await this.flightConnectionService.getConnectionById(id);
      this.connectionData = connectionData;
      const flightData = await this.flightOptionService.getFlightOption(connectionData.toUserFlightOptionId);
      this.flightData = flightData;
      console.log('loaded with data', this.connectionData);
    } catch (err) {
      console.error('unable to load connection', err);
    } finally {
      this.isLoading = false;
    }

  }

  async handleAcceptConnection() {
    this.isHandlingAccept = true;
    const friendlyRoute = getFriendlyRoute(this.connectionData.fromLocation, { locationName: this.connectionData.toLocation }); // TODO: Handle general locations
    const userProfile = await this.userService.getUserProfile();
    const acceptingUserName = userProfile.displayName;
    try {
      await this.flightConnectionService.acceptConnectionRequest(this.connectionData.id, this.connectionData.fromId, this.connectionData.fromEmail, acceptingUserName, friendlyRoute)
    } catch (err) {
      // TODO: friendly error
      console.error(err);
    } finally {
      this.isHandlingAccept = false;
      this.loadConnectionData(this.connectionData.id);
    }
  }

  async handleDeclineConnection() {
    this.isHandlingDecline = true;
    const friendlyRoute = getFriendlyRoute(this.connectionData.fromLocation, { locationName: this.connectionData.toLocation }); // TODO: Handle general locations
    const userProfile = await this.userService.getUserProfile();
    const decliningUserName = userProfile.displayName;
    try {
      await this.flightConnectionService.declineConnectionRequest(this.connectionData.id, this.connectionData.fromId, this.connectionData.fromEmail, decliningUserName, friendlyRoute);
    } catch (err) {
      // TODO: friendly error
      console.error(err);
    } finally {
      this.router.navigate(['/connections'], {
        queryParams: { tab: 'requests' }
      });
      this.isHandlingDecline = false;
    }
  }


}
